module.exports = __webpack_public_path__ + "img/video-games.3cbbb39f.jpg";